// extracted by mini-css-extract-plugin
module.exports = {"root":"Section_root__11EQJ","label":"Section_label__Lc7bL","contentWrap":"Section_contentWrap__6m6U7","footer":"Section_footer__2AZXS","footerInner":"Section_footerInner__18jsa"};